module.exports = __webpack_public_path__ + "static/Dilenyas-da89a62fcad584318e6971f4cd78cb9b.jpg";